// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__13gIQ","title":"Header_title__3ySj4","left":"Header_left__1Y3AA","clinicName":"Header_clinicName__21R77"};